const BASE = '/api/ai-trader';

export const AI_TRADER_URLS = {
  BRIEFING: `${BASE}/briefing`,
  BRIEFING_GENERATE: `${BASE}/briefing/generate`,
  SIGNAL: (symbol: string, refresh = false) =>
    `${BASE}/signal?symbol=${symbol}${refresh ? '&refresh=true' : ''}`,
  SIGNAL_ALL: `${BASE}/signal/all`,
  SIGNAL_HISTORY: (symbol: string, limit = 20) =>
    `${BASE}/signal/history?symbol=${symbol}&limit=${limit}`,
  SENTIMENT: (symbol: string) => `${BASE}/sentiment?symbol=${symbol}`,
  SENTIMENT_FEEDS: (symbol: string, limit = 10) =>
    `${BASE}/sentiment/feeds?symbol=${symbol}&limit=${limit}`,
  GLOBAL_MARKET: `${BASE}/global-market`,
  OI_LEVELS: (symbol: string) => `${BASE}/oi-levels?symbol=${symbol}`,
  OI_CHAIN: (symbol: string) => `${BASE}/oi-chain?symbol=${symbol}`,
  WEIGHT_MAP: (symbol: string) => `${BASE}/weight-map?symbol=${symbol}`,
  REFRESH_SNAPSHOTS: `${BASE}/refresh-snapshots`,
  REFRESH_SENTIMENT: `${BASE}/refresh-sentiment`,
  REFRESH_GLOBAL: `${BASE}/refresh-global`,
  DASHBOARD: (symbol: string) => `${BASE}/dashboard?symbol=${symbol}`,
  REFRESH: `${BASE}/refresh`,
  CHAT: `${BASE}/chat`,
};
